import React from "react";
import { UriPath } from "../../../services/location/uri-path/uri-path";
import { Link } from "../../raw-components/link/link";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import { SideMenuLinkProps } from "../side-menu-link.interface";
import { GenericSideMenuLinkBox } from "./boxes/link/generic-side-menu-link.box";
import { GenericSideMenuLabelBox } from "./boxes/link/generic-side-menu-label.box";
import { GenericSideMenuIconBox } from "./boxes/link/generic-side-menu-icon.box";
import { observer } from "mobx-react";
import { ISvgIconProps } from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import {GenericSideMenuPreIconBox} from "./boxes/link/generic-pre-icon-menu-link.box";

interface InternalNavSideMenuLinkProps {
    Icon: React.ComponentType<ISvgIconProps>;
    withArrow?: boolean;
}

@observer
export class InternalNavSideMenuLink extends OrbitComponent<InternalNavSideMenuLinkProps & SideMenuLinkProps> {
    render() {
        const config = this.props.config;
        const InternalNavIcon = this.props.Icon;
        const href = this.services.location.buildFullUri(config.link);
        const active = this.isLinkToCurrentPage(config.link);
        return <Link href={decodeURI(encodeURI(href.toString()))} onClick={this.onClick}>
            <GenericSideMenuLinkBox active={active}>
                <GenericSideMenuPreIconBox active={active}/>
                <GenericSideMenuIconBox active={active}>
                    <InternalNavIcon size={2} />
                </GenericSideMenuIconBox>
                <GenericSideMenuLabelBox>{ this.services.translation.translate(config.text) }</GenericSideMenuLabelBox>
                { this.props.withArrow ? <this.services.theme.currentTheme.icons.forwardIcon size={2} /> : null }
            </GenericSideMenuLinkBox>
        </Link>;
    }
    onClick = (event: React.MouseEvent) => {
        const config = this.props.config;
        /**
         * TODO: INSTEAD OF CALLING THE GENERAL getLinkAction make a dedicated handler for internal links, like:
         * this.services.sideMenu.executeInternalLink(CONST.HOME);
         */
        this.services.sideMenu.getLinkAction(config)(event);
        // run whatever else was passed by props
        if (this.props.onClick) {
            this.props.onClick();
        }
    };

    /**
     * Determine whether the given link configuration is targeting the current active page
     * (used to determine if the given link should have the "active" tag).
     */
    private isLinkToCurrentPage(link: string): boolean {
        try {
            if (!link)
                return false;

            if (link.slice(-1) === '/')  // NB: link may be "/slots/" comparing to "/slots", so trim trailing "/" from the link before comparing.
                link = link.slice(0, -1);

            const currentPath = this.services.location.currentUri.pathName;
            const candidate = new UriPath(link);

            if (currentPath.isEmpty)
                return candidate.isEmpty; // We're on the homepage, so a link to homepage is active
            if (candidate.isEmpty)
                return false; // We're *not* on the homepage, so a link to homepage is *definitely not* active

            const linkRoot = candidate.toArray()[1].toLowerCase();
            const pathRoot = currentPath.toArray()[1].toLowerCase();

            if (linkRoot !== pathRoot)
                return false; // cannot be the same link if they don't start in the same root

            return currentPath.toString().toLowerCase().indexOf(link.toLowerCase()) > -1;
        } catch(e) {
            this.services.logger.error(`Failed to compare link '${link}' to current route!`, e);
            return false;
        }
    }

}